import { Component, Input } from '@angular/core'
import {
	MatCardHeader,
	MatCardSubtitle,
	MatCardTitle,
} from '@angular/material/card'
import { NgStyle } from '@angular/common'

@Component({
	selector: 'card-title',
	templateUrl: './CardTitle.Component.html',
	imports: [MatCardHeader, NgStyle, MatCardTitle, MatCardSubtitle],
})
export class CardTitleComponent {
	@Input() public icon: string

	@Input() public image: string

	@Input() public title: string

	@Input() public subtitle: string
}
